module.exports = __webpack_public_path__ + "src/assets/textures/micropipette/plane_mat22.jpg";